import { Enum } from '../../../../enums/enum.class';
import EnumItem from '../../../../enums/enumItem.class';

class ProgressoEnum extends Enum {
    constructor() {
        super();
        this.CONCLUIDO = new ProgressoEnumItem(0, "mdi-check-circle", "#32AA45", "");
        this.EM_ANDAMENTO = new ProgressoEnumItem(1, "mdi-progress-helper", "#c8b71b", "");
        this.PENDENTE = new ProgressoEnumItem(2, "mdi-moon-full", "#d9d9d9", "");
        this.OCULTO_CONCLUIDO = new ProgressoEnumItem(3, "mdi-eye-lock", "#32AA45", "Fase de controle interno");
        this.OCULTO_EM_ANDAMENTO = new ProgressoEnumItem(4, "mdi-eye-lock", "#c8b71b", "Fase de controle interno");
        this.OCULTO_PENDENTE = new ProgressoEnumItem(5, "mdi-eye-lock", "#d9d9d9", "Fase de controle interno");
    }
}

class ProgressoEnumItem extends EnumItem {
    constructor(id, icon, color, title) {
        super(id, null);
        this.icon = icon;
        this.color = color;
        this.title = title;
    }

    getIcon() {
        return this.icon;
    }

    getColor() {
        return this.color;
    }

    getTitle() {
        return this.title;
    }

    equals(progressoEnum) {
        if(!progressoEnum) return false;
        return this.id == progressoEnum.getId();
    }
}

export const progressoEnum = new ProgressoEnum(); 